import { Injectable } from '@angular/core';
import { FacetDataService } from '../../api/services/facet-data.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { FacetData } from '../../api/models/facet-data';

@Injectable({
  providedIn: 'root'
})
export class FacetDataHolderService {

  static readonly FACET_DATA_KEY = 'facetData';
  static readonly FACET_DATA_TS_KEY = 'facetDataTimeStamp';
  static readonly CACHE_TIME = 86_400; // seconds ; 24 hours
  private subject = new BehaviorSubject<FacetData>({});

  constructor(private facetDataService: FacetDataService) { }

  getFacetData(): Observable<FacetData> {
    return this.subject.asObservable();
  }

  loadFacetDataIfNeeded(): void {
    const { FACET_DATA_KEY, FACET_DATA_TS_KEY, CACHE_TIME } = FacetDataHolderService;

    const storedFacetData = localStorage.getItem(FACET_DATA_KEY);
    const storedTimestamp = parseInt(localStorage.getItem(FACET_DATA_TS_KEY) || '0');
    const isCacheValid = storedFacetData && (Date.now() - storedTimestamp) < CACHE_TIME;

    if (isCacheValid) {
      this.nextFacetData(JSON.parse(storedFacetData));
      return;
    }

    this.facetDataService.getFacetData().subscribe(fd => {
      localStorage.setItem(FACET_DATA_KEY, JSON.stringify(fd));
      localStorage.setItem(FACET_DATA_TS_KEY, Date.now().toString());
      this.nextFacetData(fd);
    });
  }

  private nextFacetData(facetData: FacetData) {
    this.subject.next(facetData);
  }
}
